import {
  type ScanUiContext,
  type ScanUiContextEntry,
  type ScanUiContextRegistry,
} from '../types/scanContext.type';

const CLOSED_UI_CONTEXT: ScanUiContext = { open_drawer: false };

/**
 * Tracks which drawers are currently open so scan events can be enriched with UI
 * context. Drawer open state lives in local component state, so each drawer
 * publishes itself here while mounted and open.
 */
export const createScanUiContextRegistry = (): ScanUiContextRegistry => {
  const entries = new Map<symbol, ScanUiContextEntry>();

  return {
    register: (entry) => {
      const token = Symbol('scanUiContextEntry');
      entries.set(token, entry);

      return {
        release: () => {
          entries.delete(token);
        },
        update: (nextEntry) => {
          if (entries.has(token)) entries.set(token, nextEntry);
        },
      };
    },
    reset: () => entries.clear(),
    snapshot: () => {
      const topmost = Array.from(entries.values()).pop();

      if (!topmost) return { ...CLOSED_UI_CONTEXT };

      return {
        open_drawer: true,
        open_drawer_name: topmost.drawerName,
        ...(topmost.selectedOrderObjectId && {
          selected_order_object_id: topmost.selectedOrderObjectId,
        }),
        ...(topmost.selectedShipmentId && { selected_shipment_id: topmost.selectedShipmentId }),
        ...(topmost.selectedTransactionObjectId && {
          selected_transaction_object_id: topmost.selectedTransactionObjectId,
        }),
      };
    },
  };
};
